<template>
  <div class="child-modal">
    <div :style="{width: contentWidth + 'rem', marginLeft: -(contentWidth/2) + 'rem'}" class="content-box" ref="content">
      <div @click="dateBoxShow = true" class="date-select" v-if="needDate">
        <div class="icon">
          <img src="../../assets/header_menu/time.png" />
        </div>
        <div class="text">时间选择</div>
        <div class="arrow"></div>
      </div>
      <div @mouseleave="dateBoxShow = false" class="date-box" v-if="dateBoxShow">
        <Datepicker />
      </div>
      <div @click="closeModal" class="close"></div>
      <div class="title">{{ title }}</div>
      <div class="content">
        <BScroll :scrollbar="true">
          <div>
            <slot></slot>
          </div>
        </BScroll>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@/components/Common/BScroll.vue'
import Datepicker from '@/components/Common/Datepicker_sp.vue'

export default {
  name: 'ChildModal',
  props: {
    title: String,
    contentWidth: {
      type: Number,
      default: 11
    },
    needDate: {
      type: Boolean,
      default: false
    },
    closeProperties: {
      type: String,
      default: "setChildModalShow"
    }
  },
  components: {
    BScroll,
    Datepicker
  },
  data() {
    return {
      dateBoxShow: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.content.style.transform = 'scale(1)'
    }, 0)
  },
  methods: {
    closeModal() {
      this.$refs.content.style.transform = 'scale(0)'
      setTimeout(() => {
        this.$store.commit(this.closeProperties)
      }, 300)
    }
  }
}
</script>

<style scoped lang="less">
h2 {
  font-size: 10rem;
  color: #fff;
}
// .content::-webkit-scrollbar {
//   -webkit-appearance: none;
// }
// .content::-webkit-scrollbar:vertical {
//   width: 0.12rem;
//   border-radius: 0.08rem;
//   background: #0f2a57;
// }
// .content::-webkit-scrollbar-thumb {
//   border-radius: 0.08rem;
//   background: #02cbfe;
// }
.child-modal {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
  .content-box {
    max-height: 95%;
    .title {
      height: 0.8rem;
      font-size: 0.24rem;
      color: @light-blue;
      font-weight: bold;
    }
    padding: 0.3rem;
    box-sizing: border-box;
    height: 9rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -4.5rem;
    transform: scale(0);
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.45);
    .close {
      width: 0.22rem;
      height: 0.23rem;
      background: url(../../assets/close.png);
      background-size: 100% 100%;
      position: absolute;
      top: 0.14rem;
      right: 0.14rem;
      z-index: 99;
      cursor: pointer;
    }
    .content {
      overflow: hidden;
      width: 100%;
      height: 92.5%;
      box-sizing: border-box;
    }
  }
}
.date-box {
  width: 300px;
  position: absolute;
  z-index: 9999;
  right: 0.5rem;
  top: 0.7rem;
}
.date-select {
  position: absolute;
  z-index: 9999;
  top: 0.1rem;
  right: 1rem;
  height: 0.64rem;
  line-height: 0.66rem;
  float: left;
  color: @base-text-color;
  margin-left: 0.28rem;
  cursor: pointer;
  > div {
    float: left;
  }
  .icon {
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.04rem;
    margin-top: 0.17rem;
  }
  .arrow {
    width: 0.3rem;
    height: 0.3rem;
    background: url(../../assets/header_menu/arrow.png);
    background-size: 100% 100%;
    margin-top: 0.18rem;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
